import useHeightTransition from '@hooks/useHeightTransition'
import { MainMenuItem } from '@hooks/useNavigation'
import { FunctionComponent, useCallback, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import SecondLevelItem from './SecondLevelItem'

interface SecondLevelMenuProps {
  children: MainMenuItem['content']
  isVisible: boolean
}

const ItemAndSubmenuWrapper = styled.div<{ heightSetOnce: boolean }>`
  ${({ heightSetOnce }) => css`
    overflow: hidden;
    transition: height 0.3s ease-out;
    ${!heightSetOnce &&
    css`
      height: 0;
    `}
  `}
`

const SecondLevelMenu: FunctionComponent<SecondLevelMenuProps> = ({
  children,
  isVisible,
}) => {
  const [initialHeight, setInitialHeight] = useState<boolean>(false)
  const getIsVisible = useCallback(() => isVisible, [isVisible])
  const { setComponentRef, setNodeHeight, wrapperRef } = useHeightTransition({
    getIsVisible,
  })

  useEffect(() => {
    setInitialHeight(true)
    setNodeHeight(isVisible)
  }, [setNodeHeight, isVisible])

  if (!children?.length) {
    return null
  }

  return (
    <ItemAndSubmenuWrapper ref={setComponentRef} heightSetOnce={initialHeight}>
      {children?.map((item) => (
        <SecondLevelItem key={item.title} {...item} parentRef={wrapperRef} />
      ))}
    </ItemAndSubmenuWrapper>
  )
}

export default SecondLevelMenu
